import React from 'react';
import Stack from '@mui/material/Stack';
import { useState, useEffect, useRef } from 'react';
import FormControl from '@mui/material/FormControl';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import axios from '../../../utils/fvAxios';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { ToastContainer, toast } from 'react-toastify';
import { HasScreenPermissions, HasPermissions } from '../../../utils/Token';
import { useTranslation } from "react-i18next";
import {
    Card, Divider, Box, Grid, RadioGroup, FormControlLabel, Radio, TextField, Checkbox,
    ListSubheader, ListItemText, Button
} from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';


export default function MFAConfiguration() {
    const toastNotify = (message, isSuccess = true) => {
        if (isSuccess) {
            toast.success(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };



    const [Dis, setDis] = useState(false);
    const [spinner, setSpinner] = React.useState(false);
    const [AuthenticationType, setAuthenticationType] = useState(1);
    const [isActive, setisActive] = useState(1);
    const { t } = useTranslation();


    useEffect(() => {
        GetMFAConfigurtionDetails();
    }, []);


    const GetMFAConfigurtionDetails = async () => {
        setSpinner(true);
        axios.get("Login/GetMFAConfigurtionDetails")
            .then((res) => {
                if (res?.data?.responseCode == 100) {
                    if (res?.data?.data == null) {
                        setAuthenticationType(1);
                        setisActive(1);
                    } else {
                        setisActive(res?.data?.data?.isActive == true ? 1 : 2);
                        setAuthenticationType(res?.data?.data?.authenticationType);
                    }
                } else {
                    toastNotify(res?.data?.responseMessage, false);
                }
            }).catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setSpinner(false);
            });
    }

    const SaveMembershipFee = async () => {
        setSpinner(true);
        setDis(true);
        if (AuthenticationType != "") {
            const data = {
                "authenticationType": AuthenticationType,
                "isActive": isActive == 1 ? true : false
            }
            axios.post("Login/AddMFAConfigurtionDetails", data)
                .then((res) => {
                    if (res?.data?.responseCode == 100) {
                        GetMFAConfigurtionDetails();
                        toastNotify(res?.data?.responseMessage, true);
                    } else {
                        toastNotify(res?.data?.responseMessage, false);
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    setSpinner(false);
                    setDis(false);
                });
        } else {
            toastNotify("Please enter mandatory fields", false);
            setDis(false);
            setSpinner(false);
        }
    }


    return (
        <>
            <ToastContainer />
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={spinner}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Card>
                <div style={{ marginLeft: "10px", marginTop: "10px" }}>
                    <div style={{ marginLeft: "15px", marginBottom: "15px" }}>
                        <h3>Multi-Factor Authentication  Configuration</h3>
                    </div>
                </div>
                <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />

                <Box >

                    <div className='mx-4 mt-3 '>

                        <Stack direction={"row"}>
                            <span className='mt-2' style={{ color: "#3E4A62" }}>Is Active:  <span style={{ color: "red" }}>*</span></span>
                            <FormControl>
                                <RadioGroup
                                    sx={{ paddingLeft: "120px" }}
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    name="radio-buttons-group"
                                    value={isActive}
                                    onClick={(e) => {
                                        setisActive(e?.target?.value);
                                    }}
                                >
                                    <Stack direction={"row"} spacing={5}>
                                        <FormControlLabel value={1} control={<Radio />} label="Yes" />
                                        <FormControlLabel value={2} control={<Radio />} sx={{ paddingLeft: "15px" }} label="No" />
                                    </Stack>

                                </RadioGroup>
                            </FormControl>
                        </Stack>
                    </div>
                    <div className='mx-4 mt-3 ' hidden={isActive == 2}>
                        <Stack direction={"row"}>
                            <span className='mt-2' style={{ color: "#3E4A62" }}>Authentication Type:  <span style={{ color: "red" }}>*</span></span>
                            <FormControl>
                                <RadioGroup
                                    sx={{ paddingLeft: "32px" }}
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    name="radio-buttons-group"
                                    value={AuthenticationType}
                                    onClick={(e) => {
                                        setAuthenticationType(e?.target?.value);
                                    }}
                                >
                                    <Stack direction={"row"} spacing={1}>
                                        <FormControlLabel value={1} control={<Radio />} label="Email OTP" />
                                        <FormControlLabel value={2} control={<Radio />} label="Captcha OTP" />
                                    </Stack>

                                </RadioGroup>
                            </FormControl>
                        </Stack>
                    </div>

                    <div className='mx-4 mt-2 mb-3 text-right'>
                        <Button variant="contained" sx={{ padding: "15px" }} disabled={Dis} onClick={SaveMembershipFee}> Save </Button>
                    </div>


                </Box >

            </Card>

        </>
    )
}


